import { Instruction } from "./instructions";
import { Card, Pile, PlayerState } from "./types";

export class Player {
  public deck: number[] = [];
  public hand: number[][] = [];
  public state: PlayerState = { kind: "idle" };

  public constructor(deck: number[], hand?: number[][] | undefined) {
    this.deck = deck;
    if (!hand) {
      this.refillHand();
    } else {
      this.hand = hand;
    }
    this.assertValidHand();
  }

  private assertValidHand(): void {
    if (this.hand.length < 4 && this.deck.length > 0) {
      throw new Error("Invalid hand configuration: " + this.toString());
    }
  }

  // Valid Move: Rank is +/- 1 (wrapping Ace and King)
  public static isValidMove(source: number, target: number): boolean {
    const diff = Math.abs(Card.rank(source) - Card.rank(target));
    return diff === 1 || diff === 12; // 12 handles Ace(1) vs King(13)
  }

  // tries to play the card on the handIndex stack onto the pile
  // refills the hand if needed
  // returns true if the operation succeeded
  public tryPlay(handIndex: number, pile: Pile): boolean {
    if (handIndex >= this.hand.length || handIndex < 0) {
      throw new Error("hand index out of range");
    }
    const stack: number[] = this.hand[handIndex];
    if (pile.isEmpty()) {
      return false;
    }
    if (!Player.isValidMove(stack[stack.length - 1], pile.peek()!)) {
      return false;
    }
    const toPlay: number = stack.pop()!;
    pile.push(toPlay);
    this.hand = this.hand.filter((s: number[]) => {
      return s.length > 0;
    });
    return true;
  }

  // if there are cards left in the deck, try to fill all 4 available slots
  // with as much cards as possible, stacking ones with the same rank
  private refillHand(): void {
    while (Instruction.tryUncover(this));
  }

  /// returns the total number of cards in this hand + deck
  public cardCount(): number {
    return (
      this.hand.reduce((acc, slot) => {
        return acc + slot.length;
      }, 0) + this.deck.length
    );
  }

  public toString(): string {
    return (
      "deck cards: " +
      this.deck.length +
      "hand cards: " +
      Number(this.cardCount() - this.deck.length)
    );
  }
}
